import { get } from 'lodash'

export default {
  methods: {
    replaceFeatureParams(expression, param) {
      const value = get(window, param.substring(1), '')
      return expression.replace(param, value)
    },
    resolveOverlayParams(overlays) {
      for (const overlay of Object.values(overlays)) {
        const features = get(overlay, 'data.features', [])

        if (features && Array.isArray(features)) {
          features.forEach((feature) => {
            const expression = get(feature, 'properties.tooltip', '')
            let tooltip = `${expression}`
            const params = expression.match(/:(\S+)/g) // @regex anything after ':' except spaces
            if (params) {
              params.forEach((param) => {
                tooltip = this.replaceFeatureParams(tooltip, param)
              })
            }
            this.setTooltip(feature, tooltip)
          })
        }
      }
      return overlays
    },
    setTooltip(feature, tooltip) {
      feature.properties.tooltip = tooltip
    },
  },
}
